import { DOWNLOAD_VENDOR_DOCUMENTS } from '../../useVendorDocumentsService';
import { DocumentStorageItemType } from 'framework/documentStorage';
import { DownloadIcon } from 'framework/ui/mui-builder';
import { useArtifactDownloadHelper } from 'domain/shared/artifact';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';
import { DEFAULT_ERROR_MESSAGE } from 'framework/form';
import { DropdownMenuActions } from 'framework/ui/menu';

const VendorDocumentActions = () => {
  const { addMessage } = useMessageService();
  const { downloadDocumentStorage } = useArtifactDownloadHelper();
  const handleDownload = async (filePath: string) => {
    try {
      await downloadDocumentStorage(filePath);
    } catch {
      addMessage(new ErrorMessage(DEFAULT_ERROR_MESSAGE));
    }
  };

  return (
    <DropdownMenuActions
      actions={[
        {
          permission: DOWNLOAD_VENDOR_DOCUMENTS,
          onClick: (entityData: DocumentStorageItemType) => {
            handleDownload(entityData?.path);
          },
          icon: <DownloadIcon />,
          title: 'Download',
        },
      ]}
    />
  );
};

export default VendorDocumentActions;
